import { createActionCreator } from '../common/actions'
import type { User } from '../users/reducer'

export const SubscribersWereFetched = createActionCreator<{
    jobID: JobID
    subscribers: User[]
}>('SUBSCRIBERS_WERE_FETCHED')
